// Design system styles (preflight + component classes). App's own index.css is imported after so it wins.
import "@instacover/ui/styles.css"
import "@fontsource/open-sans/300.css"
import "@fontsource/open-sans/400.css"
import "@fontsource/open-sans/600.css"
import "@fontsource/open-sans/700.css"
import "@fontsource/open-sans/800.css"
import "@fontsource/poppins/300.css"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"
import "@fontsource/poppins/800.css"
import "./index.css"

import { withProfiler } from "@sentry/react"
import { createRoot } from "react-dom/client"

import { App } from "./App"
import { getElementByIdOrThrow, initFullHeightHack } from "./utils/browser"
import { initCrashRecovery } from "./utils/monitoring/crashRecovery"
import { initFaro } from "./utils/monitoring/faro"
import { initSentry } from "./utils/monitoring/sentry"

initSentry("client")
initFaro("client") // PoC - běží paralelně se Sentry
initCrashRecovery() // detekce pádů appky (WebKit crash / OOM) — IC-2969
initFullHeightHack()

// When the SW updates (autoUpdate), old chunk URLs are evicted from precache.
// Any in-flight dynamic import of an old chunk gets a 404 → "Importing a module script failed".
// One automatic reload recovers the user; sessionStorage prevents an infinite loop.
window.addEventListener("unhandledrejection", (event) => {
  const msg = String(event.reason)
  if (msg.includes("Importing a module script failed") || msg.includes("dynamically imported module")) {
    if (!sessionStorage.getItem("sw-chunk-reload")) {
      sessionStorage.setItem("sw-chunk-reload", "1")
      window.location.reload()
    }
  }
})

const container = getElementByIdOrThrow("app")
const root = createRoot(container)

const AppWithProfiler = withProfiler(App)
root.render(<AppWithProfiler />)
